import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { App } from './App';
import './styles/globals.css';

/**
 * Sentry front (push 12/08, reconstruit 13/08 depuis le changelog — si la
 * version du repo diffère, elle fait foi). Armé UNIQUEMENT en build de prod
 * avec un DSN : le dev local et les previews restent muets, et le produit ne
 * dépend jamais de Sentry. Même minimisation que le serveur : pas de PII,
 * pas de replay, pas de tracing (quota 5k events/mois partagé org EU OFAD).
 */
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (import.meta.env.PROD && sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: 'production',
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
}

const container = document.getElementById('root');
if (!container) throw new Error('Root container missing');

createRoot(container).render(
  <StrictMode>
    {/* Le fallback est la DERNIÈRE digue : si React lui-même s'effondre,
        l'administré voit un message en français, pas une page blanche. */}
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'system-ui' }}>
          <h1>Une erreur est survenue</h1>
          <p>
            L'incident a été signalé automatiquement. Rechargez la page — si le
            problème persiste, contactez votre mairie.
          </p>
          <button type="button" onClick={() => window.location.reload()}>
            Recharger la page
          </button>
        </div>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);

// Enregistre le service worker : Web Push (alertes municipales) + PWA
// (cache du shell, installation, résilience hors-ligne). Voir public/sw-push.js.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker
      .register('/sw-push.js')
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('Service worker enregistrement échoué :', err);
      });
  });
}
